import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { scheduleLocalMarketProcessing } from './lib/marketProcessing';
import './styles.css';

scheduleLocalMarketProcessing();

createRoot(document.getElementById('root')!).render(<StrictMode><BrowserRouter><App/></BrowserRouter></StrictMode>);
